import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Subscription } from 'rxjs/Rx';

import {Attack, AttackProfile} from '../../attack/attack';
import { AttackService } from '../../attack/attack.service';
import {GaugeComponent} from '../../components/gauge/gauge.component';
import {ConfigService} from '../config/config.service';
import { TargetValidationService } from '../../main/target-validation/target-validation.service';
import {LoginService} from '../../login/user-login.service';
import {ProgressbarComponent} from '../../components/progressbar/progressbar.component';


export enum aResultsState {
    RUNNING = 'running',
    LOADING = 'loading',
    COMPLETE = 'complete',
    INFO = 'info',
    WELCOME = 'welcome',
    FAIL = 'fail'
}
@Component({
    selector: 'ddos-attack-results',
    templateUrl: './ddos-attack-results.component.html',
    styleUrls: [
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css',
        './ddos-attack-results.component.scss'

    ]
})
export class DdosAttackResultsComponent implements OnInit, OnDestroy {
    @ViewChild('gauge') private gauge: GaugeComponent;
    @ViewChild('loadProgressBar') private loadProgressBar: ProgressbarComponent;


    state: string = aResultsState.LOADING;
    loadingMessasge: string = 'LOADING';
    failReason: string = '';
    currentAttack: Attack;
    runningTime: number;
    formattedDateTime: string='';
    framesPerSecond: string = '0';
    framesSent: string = '0';
    throughput: number = 0;
    availableAttackProfiles: AttackProfile[] = [];
    outboundData: string = '0';
    view: any[] = [400, 400];
    private currentAttackSubscription: Subscription;
    //Let the app know if the user has loggedIn since the last test has run.
    //Should return to false once a test has run
    userLoggedIn : boolean = false;

    showCheckBoxes: boolean = false;
    readyToRun: boolean = false;

    constructor(
        private attackService: AttackService, private cfgService: ConfigService,
        private targetValidationService: TargetValidationService,
        private loginService: LoginService
    ) {
        this.loginService.userLoggedInSubject
            .subscribe((value) => {
                this.userLoggedIn = value;
            });
    }

    onGaugeCreated(value: boolean) {
  //      this.processCurrentAttack(this.currentAttack);

    }


    ngOnInit() {

        //Reveal to get loading progress example
        /*var me = this;
        setTimeout(() => {
            if(me.loadProgressBar) {
                me.loadProgressBar.updateProgress(50, '02 of 05 Source IPs reserved');
            }
        }, 5000);*/



        this.currentAttackSubscription = this.cfgService.currentAttackSubject.subscribe(attack => this.processCurrentAttack(attack));

        this.cfgService.availableAttackProfilesSubject
            .subscribe(
                (profiles) =>{
                    this.availableAttackProfiles = profiles;
                }
            );


    }

    processCurrentAttack(attack: Attack) {
        var me = this;
        if(attack){
            this.currentAttack = attack;
            if(attack.Status === 'Queued' || attack.Status === 'Preparing' ||  attack.Status === 'Starting' || attack.Status === 'Created'){
                this.resetAttackResults();
                this.userLoggedIn = false;
            }

            if(attack.Status === 'Queued' || attack.Status === 'Preparing' ||  attack.Status === 'Starting') {
                this.loadingMessasge = attack.Status;
                this.state = aResultsState.LOADING;
            } else if (attack.Status === 'Created') {
                this.loadingMessasge = 'Validating';
                this.state = aResultsState.LOADING;
            }else if( (attack.Status === 'Started') || attack.Status === 'Stopping') {
                this.state = aResultsState.RUNNING;
            }else if(attack.Status === 'Stopped') {
                this.state = aResultsState.COMPLETE;
            }
            else if(attack.Status === 'Failed') {
                this.state = aResultsState.FAIL;
                this.failReason = attack.FailReason;
            }else{
                    this.state = aResultsState.LOADING;
                    setTimeout(() => {
                        if(attack.Status === null){
                          this.state = aResultsState.WELCOME;
                        }
                      }, 10000);
            }


            if(this.gauge && attack['Metrics']){

                //Give the UI a .5 millisecond timeout to prevent DE9049
                if ( attack.Status === 'Stopped') {
                    setTimeout(()=> {
                        this.updateAttack(attack);
                    }, 500);
                } else{
                    this.updateAttack(attack);
                }
            }
        } else {
          this.state = aResultsState.LOADING;
            setTimeout(() => {
                if(!me.currentAttack || me.currentAttack.Status === 'Unknown'){
                  this.state = aResultsState.WELCOME;
                }
              }, 3000);

            //this.state = aResultsState.LOADING;
        }
        //this.state = aResultsState.WELCOME;
    }

    updateAttack(attack: Attack){
        this.runningTime = attack && attack.StartDate && (((attack.StopDate ? Date.parse(attack.StopDate) : new Date().getTime()) - Date.parse(attack.StartDate)) / 1000);
        this.formattedDateTime = this.cfgService.formatDateTime(attack.StartDate);
        this.gauge.animateGauge(this.getGaugePercentage(attack));
        this.throughput = this.bytesPerSecondToMegabitsPerSecond(attack['Metrics'].TxDataRate);
        this.gauge.updateGauge(String(this.throughput));
        this.framesPerSecond = String(attack['Metrics'].TxFrameRate);
        this.framesSent = String(attack['Metrics'].TxFrames);
        this.outboundData = String(attack['Metrics'].TxData);
    }

    resetAttackResults() {
        if (this.gauge) {
            this.gauge.animateGauge(0);
            this.gauge.updateGauge('0');
        }
        this.framesPerSecond = '0';
        this.framesSent = '0';
        this.runningTime = 0;
    }

    ngOnDestroy() {
        this.currentAttackSubscription.unsubscribe();
    }

    getGaugePercentage( attack: any ){
        const max = this.getMaxofSize(attack);
        if (!max) {
            return 0;
        }
        let rate = this.bytesPerSecondToMegabitsPerSecond(attack['Metrics'].TxDataRate);
        return (rate * 100) / max;
    }

    getMaxofSize(attack: any){
        this.availableAttackProfiles;
        for (let i of this.availableAttackProfiles){
            if(i.Name === attack.AttackParams.AttackProfile){
                for (let size of i.Sizes){
                    if(size.Name === attack.AttackParams.AttackSize){
                        return size.max;
                    }
                }
            }
        }
    }



    bytesPerSecondToMegabitsPerSecond( bytes: number ) {
        let val:number = bytes / 1000;
        val = val / 1000;
        val = val * 8;
        return Math.round( val );
    }


    openWelcomeScreenLink(theLink:string, isExternal:boolean) {
      if(isExternal){
        window.open(theLink, '_blank');
      }else{
        let url = window.location.protocol + '//' + window.location.hostname + ':' +
            window.location.port + theLink;
        window.open(url, '_blank');
      }

    }


    openTargetValidationService(){
      this.targetValidationService.showDialog();
    }


}



// WEBPACK FOOTER //
// ./src/app/main/ddos-attack-results/ddos-attack-results.component.ts